<div class="tw-flex tw-gap-2 tw-items-center">
  @if (startIcon()) {
    <i [class]="['bwi', startIcon()]" aria-hidden="true"></i>
  }
  <span class="empty:tw-hidden">
    <ng-content></ng-content>
  </span>
  @if (endIcon()) {
    <i [class]="['bwi', endIcon()]" aria-hidden="true"></i>
  }
</div>
